import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Editor from 'react-medium-editor';
import { isEmpty } from 'lodash';
import 'medium-editor/dist/css/medium-editor.css';
import 'medium-editor/dist/css/themes/flat.css';
import { isFirefox } from '../../common/helpers/browser';

const buildToolbarOptions = editable => (editable ? {
  buttons: [
    { name: 'bold', contentDefault: '<span class="toolbar-icon toolbar-icon--bold" />' },
    { name: 'italic', contentDefault: '<span class="toolbar-icon toolbar-icon--italic" />' },
    { name: 'underline', contentDefault: '<span class="toolbar-icon toolbar-icon--underline" />' },
    { name: 'justifyLeft', contentDefault: '<span class="toolbar-icon toolbar-icon--left-alignment" />' },
    { name: 'justifyCenter', contentDefault: '<span class="toolbar-icon toolbar-icon--center-alignment" />' },
    { name: 'justifyRight', contentDefault: '<span class="toolbar-icon toolbar-icon--right-alignment" />' },
    { name: 'anchor', contentDefault: '<span class="toolbar-icon toolbar-icon--link" />' },
  ],
} : false);

class EditableText extends Component {
  componentDidUpdate(prevProps) {
    if (isEmpty(prevProps.value) && !isEmpty(this.props.value)) {
      if (this.editor) {
        const placeholder = this.editor.medium.getExtensionByName('placeholder');
        if (placeholder) {
          // eslint-disable-next-line react/no-find-dom-node
          placeholder.updatePlaceholder(ReactDOM.findDOMNode(this.editor));
        }
      }
    }
  }

  render() {
    const { editable, value, defaultText, onChange, ...rest } = this.props;
    return (
      <Editor
        ref={(editor) => { this.editor = editor; }}
        tag="div"
        className="c-editable-text"
        text={value}
        onChange={onChange}
        options={{
          disableEditing: !editable,
          toolbar: buildToolbarOptions(editable),
          placeholder: editable ? { text: defaultText, hideOnClick: isFirefox() } : false,
        }}
        {...rest}
      />
    );
  }
}

EditableText.propTypes = {
  value: PropTypes.string,
  editable: PropTypes.bool,
  defaultText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

EditableText.defaultProps = {
  value: '',
  editable: true,
  defaultText: 'This text is editable. Click to edit the message.',
};

export default EditableText;
